
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-19 -10 38 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#75b2dd","d":"M-19-10h38v20h-38z"}}),_c('g',{attrs:{"id":"c","transform":"translate(0 -6)","fill":"#fff"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-2v2h1","transform":"rotate(18 0 -2)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(90)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(180)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(270)"}})])
          )
        }
      }
    